class CartService extends React.Component {
  constructor(props) {
    super(props);
    this.carts = [];
    this.totalcart = 0;
    this.state = {
      buyNowDetails : []
    }
  }

  setdata(result) {
    /* RESETTING LOGGED IN USER DATA */
    if (result.data) {
      Object.keys(result.data).map((key) => {
        Object.keys(result.data[key].learners).map((item) => {
          if (result.data[key].learners[item].discount_price && result.data[key].learners[item].discount_price > 0) {
            result.data[key].learners[item].is_bulk_learner_discount = 0;
            result.data[key].learners[item].discount_price       = 0;
            result.data[key].learners[item].total_after_discount = 0;
          }
        })
      })
    }

    localStorage.setItem(
      'mycart',
      result.data ? JSON.stringify(result.data) : '{}'
    );
    localStorage.setItem(
      'mycart_count',
      Object.keys(result.data).length ? Object.keys(result.data).length : 0
    );
    this.carts = result.data ? result.data : {};
    this.totalcart = localStorage.getItem('mycart_count')
      ? localStorage.getItem('mycart_count')
      : 0;
  }

  filter_meta = (data) => {
    var cart = JSON.parse(data);
    var filterd_cart = {};
    Object.keys(cart['data']).forEach((key) => {
      var metadata = {};
      metadata['metadata'] = cart['data'][key].metadata
        ? cart['data'][key].metadata
        : {};
      filterd_cart[key] = metadata;
    });
    cart['data'] = filterd_cart;
    return JSON.stringify(cart);
  };

  getCouponRemaining = async (coupon_id) => {
    try {
      var res = await fetch(api_url + '/reverse_coupon_remaining', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({coupon_id})
      });
      var data = await res.json();
      return data;
    } catch(error) {
      console.log(error);
    }
  }

  updateCartDetails = async(mycart) => {
    try {
      var res = await fetch(api_url + '/update_cart_details', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: mycart
      });
      var data = await res.json();
      return data;
    } catch(error) {
      console.log(error);
    }
  }
  
  async init() {
    // if (__isLoggedin) {
    if (!__isLoggedin) _sync = true;
    try {
      var data = {
        data: JSON.parse(
          localStorage.getItem('mycart') ? localStorage.getItem('mycart') : '[]'
        ),
        address: JSON.parse(
          localStorage.getItem('myaddress')
            ? localStorage.getItem('myaddress')
            : '[]'
        ),
      };
      data = JSON.stringify(data);
      var res = await fetch(api_url + '/get_mycart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body:
          localStorage.getItem('mycart') && _sync
            ? data
            : this.filter_meta(data),
      });
      var data = await res.json();
      this.setdata(data);
    } catch (error) {
      console.groupCollapsed('caught error');
      console.log(error);
      console.groupEnd();
    }
    // }
    // else {
    // 	data = {
    // 		'error': false,
    // 		'data': JSON.parse(localStorage.getItem('mycart')),
    // 		'pps_required': false,
    // 	};
    // }

    return data;
  }

  async removeItem(id, type) {
    if (__isLoggedin) {
      try {
        var res = await fetch(api_url + '/remove_item', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: id, type: type }),
        });
        var data = await res.json();
      } catch (error) {
        console.groupCollapsed('caught error');
        console.log(error);
        console.groupEnd();
      }
    } else {
      data = {
        status: true,
      };
    }
    
    if (data.status) {
      this.carts = JSON.parse(localStorage.getItem('mycart'));
      delete this.carts[type + '_' + id];
      localStorage.setItem('mycart', JSON.stringify(this.carts));
      localStorage.setItem('mycart_count', Object.keys(this.carts).length);
      $('.cart-sec #cart_count').text(localStorage.getItem('mycart_count'));
      return true;
    } else {
      return false;
    }
  }

  getCartCount() {
    return this.totalcart;
  }

  getCart() {
    var cart = localStorage.getItem('mycart');
    if (cart == '[]') {
      localStorage.setItem('mycart', '{}');
    }
    if (_buyNow) {
      cart = {};
      cart[_buyNow] = _buyNowDetails;
      return cart;
    }
    cart = JSON.parse(localStorage.getItem('mycart'));
    return cart;
  }

  getCartItem(index) {
    var cart = localStorage.getItem('mycart');

    if (_buyNow) {
      return _buyNowDetails;
    }

    if (cart == '[]') {
      return null;
    }
    cart = JSON.parse(cart);
    return cart[index];
  }
  is_pps_required = () => {
    var pps = false;
    var cart = localStorage.getItem('mycart');
    if (_buyNow) {
      cart = {};
      cart[_buyNow] = _buyNowDetails;
      Object.keys(cart).forEach((item) => {
        // console.log(cart[item].others.pps_required);
        if (cart[item].others.pps_required == true) pps = true;
      });
      return pps;
    }
    if (cart == '[]') {
      pps = false;
    }
    cart = JSON.parse(localStorage.getItem('mycart'));
    Object.keys(cart).forEach((item) => {
      // console.log(cart[item].others.pps_required);
      if (cart[item].others.pps_required == true) pps = true;
    });
    return pps;
  };

  async checkMobileNumber(data, index, oldindex = null){
      try {
        var res = await fetch(api_url + '/checkMobileNumber', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: data ? JSON.stringify({ data: data, index: index }) : '{}',
        });
        var data = await res.json();
        return data;
      } catch (error) {
        //console.groupCollapsed('caught error');
        //console.log(error);
        //console.groupEnd();
      }
      //.then()
      // .then()
      // .catch();
    
  }


  async addLearner(data, index, oldindex = null, isedit = false) {
    var cart = localStorage.getItem('mycart');
    if (cart == '[]') {
      localStorage.setItem('mycart', '{}');
    } else {
      cart = JSON.parse(localStorage.getItem('mycart'));
      if (__isLoggedin && !_buyNow) {
        try {
          var res = await fetch(api_url + '/addlearner', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: data ? JSON.stringify({ data: data, index: index }) : '{}',
          });
          var ismemberdata = await res.json();
        } catch (error) {
          //console.groupCollapsed('caught error');
          //console.log(error);
          //console.groupEnd();
        }
        //.then()
        // .then()
        // .catch();
      } else {
        try {
          var courseMemberStatus = 0;
          //console.log(index, 'index'); //-buynow-change
          if (typeof cart[index] != 'undefined') {
            if (typeof cart[index]['others']['member_status'] === 'undefined') {
              courseMemberStatus = '0';
            } else {
              courseMemberStatus = cart[index]['others']['member_status'];
            }
          } else {
            //-buynow-change
            if (typeof _buyNowDetails.others['member_status'] === 'undefined') {
              courseMemberStatus = '0';
            } else {
              courseMemberStatus = _buyNowDetails.others['member_status'];
            }
            //console.log(courseMemberStatus, 'courseMemberStatus');
          }
          var res = await fetch(api_url + '/validate_membership', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: data
              ? JSON.stringify({
                  data: data,
                  index: index,
                  coursestatus: courseMemberStatus,
                  validType: 1,
                })
              : '{}',
          });
          var ismemberdata = await res.json();
          if(ismemberdata.error){
           // alert("email exist");
          
            var error_index = 'phone';
            var message = 'User already added';
            return error_index;
           // return error_index;
            // var error = field_error(e.target, null, { iserror: true, message }, error_index);
            this.setState({
              event_warning: false,
              useradded: true,
            },);
          }
          console.log(ismemberdata, 'ismember_notlogin');
        } catch (error) {
          console.log(error);
        }
      }
      //-buynow-change
      let learnerIndex = oldindex ? oldindex : data.email;
      if (isedit)
      {
        delete cart[index].learners[learnerIndex];
        learnerIndex = data.email;
      }
      if (_buyNow) {
        cart = {};
        _buyNowDetails[learnerIndex] = { ...data, ...ismemberdata };
        if(Object.keys(_buyNowDetails.learners).length === 0) {
          _buyNowDetails.learners = {}
        }
        _buyNowDetails.learners[learnerIndex] = { ..._buyNowDetails[learnerIndex] };
        cart[_buyNow] = _buyNowDetails;
      }
      if (!_buyNow){
        cart[index].learners[learnerIndex]   = { ...data, ...ismemberdata };
        cart[index].learners = { ...cart[index].learners };
      }
     
      if (_buyNow) _buyNowDetails = cart[_buyNow];
      localStorage.setItem('mycart', JSON.stringify(cart));
    }
    return 1;
  }


  async addWaitingListLearner(data, index, oldindex = null, isedit = false) {
    // Retrieve cart from localStorage
    var cart = localStorage.getItem('mycart');
    if (cart == '[]') {
      localStorage.setItem('mycart', '{}');
    } else {
      cart = JSON.parse(localStorage.getItem('mycart'));
  
      // If user is logged in and not using "buy now"
      if (__isLoggedin && !_buyNow) {
        try {
          var res = await fetch(api_url + '/addWaitingList', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: data ? JSON.stringify({ data: data, index: index }) : '{}',
          });
          var waitingListResponse = await res.json();
        } catch (error) {
          console.error('Error adding to waiting list:', error);
        }
      } else {
        // If not logged in or using "buy now"
        try {
          var courseMemberStatus = 0;
  
          if (typeof cart[index] != 'undefined') {
            if (typeof cart[index]['others']['member_status'] === 'undefined') {
              courseMemberStatus = '0';
            } else {
              courseMemberStatus = cart[index]['others']['member_status'];
            }
          } else {
            if (typeof _buyNowDetails.others['member_status'] === 'undefined') {
              courseMemberStatus = '0';
            } else {
              courseMemberStatus = _buyNowDetails.others['member_status'];
            }
          }
  
          var res = await fetch(api_url + '/validate_membership', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: data
              ? JSON.stringify({
                  data: data,
                  index: index,
                  coursestatus: courseMemberStatus,
                  validType: 1,
                })
              : '{}',
          });
          var waitingListResponse = await res.json();
  
          // Handle error if already added to waiting list
          if (waitingListResponse.error) {
            var error_index = 'phone';
            var message = 'User already added to waiting list';
            return error_index;
          }
  
          console.log(waitingListResponse, 'waitingList_notLoggedin');
        } catch (error) {
          console.error('Error validating membership:', error);
        }
      }
  
      // Define waiting list key (same logic as for learners)
      let waitingListIndex = oldindex ? oldindex : data.email;
      if (isedit) {
        delete cart[index].waitingList[waitingListIndex];
        waitingListIndex = data.email;
      }
  
      // Handle "buy now" logic
      if (_buyNow) {
        cart = {};
        _buyNowDetails[waitingListIndex] = { ...data, ...waitingListResponse };
        if (!_buyNowDetails.waitingList) {
          _buyNowDetails.waitingList = {};
        }
        if (Object.keys(_buyNowDetails.waitingList).length === 0) {
          _buyNowDetails.waitingList = {};
        }
        _buyNowDetails.waitingList[waitingListIndex] = { ..._buyNowDetails[waitingListIndex] };
        cart[_buyNow] = _buyNowDetails;
      }
  
      // If not using "buy now"
      if (!_buyNow) {
        if (!cart[index].waitingList) {
          cart[index].waitingList = {};
        }
        cart[index].waitingList[waitingListIndex] = { ...data, ...waitingListResponse };
        cart[index].waitingList = { ...cart[index].waitingList };
      }
  
      // Store the updated cart back in localStorage
      if (_buyNow) _buyNowDetails = cart[_buyNow];
      localStorage.setItem('mycart', JSON.stringify(cart));
    }
    return 1;
  }
  
  getitemprice(index) {
    var cart = localStorage.getItem('mycart');
    if (_buyNow) {
      cart = {};
      cart[_buyNow] = _buyNowDetails;
      return cart[index] ? cart[index].others : [];
    }
    if (cart == '[]' || cart == '{}' || !cart) {
      return [];
    } else {
      cart = JSON.parse(localStorage.getItem('mycart'));
      //console.log(cart[index].others, ' cart[index].others');
      return cart[index] ? cart[index].others : [];
    }
  }

  checkmemEnabled(data, courseindex) {
    var course_mem_status = 0;
    var is_member = 0;
    //-buynow-change
    if (_buyNow) {
      cart = _buyNowDetails;
      //console.log(cart, ' cart[index].others');
      course_mem_status = cart.others.member_status;
      if (cart.learners[data.email] != undefined) {
        is_member = cart.learners[data.email].is_member;
      }
      if (_showMember == '1' && course_mem_status == '1') {
        if (is_member == '1') {
          return 1;
        } else {
          return 2;
        }
      }
      return 0;
    }

    var cart = localStorage.getItem('mycart');
    if (cart == '[]' || cart == '{}' || !cart) {
      return 0;
    } else {
      cart = JSON.parse(localStorage.getItem('mycart'));
      //console.log(cart, ' cart[index].others');
      course_mem_status = cart[courseindex].others.member_status;
      if (cart[courseindex].learners[data.email] != undefined) {
        is_member = cart[courseindex].learners[data.email].is_member;
      }
      if (_showMember == '1' && course_mem_status == '1') {
        if (is_member == '1') {
          return 1;
        } else {
          return 2;
        }
      }
      return 0;
    }
  }

  getLearner(index) {
    var cart = localStorage.getItem('mycart');

    if (_buyNow) {
      cart = {};
      cart[_buyNow] = _buyNowDetails;
      return cart[_buyNow] ? cart[_buyNow].learners : [];
    }
    if (cart == '[]' || cart == '{}' || !cart) {
      return [];
    } else {
      cart = JSON.parse(localStorage.getItem('mycart'));
      return cart[index] ? cart[index].learners : [];
    }
  }
  getWaitingList(index) {
    var cart = localStorage.getItem('mycart');
  
    if (_buyNow) {
      cart = {};
      cart[_buyNow] = _buyNowDetails;
      return cart[_buyNow]?.waitingList || [];
    }
  
    if (cart == '[]' || cart == '{}' || !cart) {
      return [];
    } else {
      cart = JSON.parse(localStorage.getItem('mycart'));
      return cart[index]?.waitingList || [];
    }
  }

  removeLearner(index, data) {

    var cart = localStorage.getItem('mycart');
    if (cart == '[]') {
      localStorage.setItem('mycart', '{}');
      return;
    }

    var found = '',
      item_found = 0;
    cart = JSON.parse(localStorage.getItem('mycart'));

    if (_buyNow) {
      cart = {};
      cart[_buyNow] = _buyNowDetails;
      // delete cart[index].learners[data.email];
      delete cart[index].learners[data.email];
      _buyNowDetails = cart[_buyNow];
      return;
    }

    if (__isLoggedin) {
      fetch(api_url + '/removelearner', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data ? JSON.stringify({ data: data, index: index }) : '{}',
      })
        .then()
        .then()
        .catch();
    }

    delete cart[index].learners[data.email];
    localStorage.setItem('mycart', JSON.stringify(cart));

    // LIMIT MANAGEMENT
    if (data.total_after_discount && data.total_after_discount > 0) {
      var masterLimit = localStorage.getItem('main_coupon_limit') ? localStorage.getItem('main_coupon_limit') : 0;
      var prevLimitRC = localStorage.getItem('limit_remaining_coupon') ? localStorage.getItem('limit_remaining_coupon') : 0;

      if (masterLimit)
      {
        if (masterLimit > prevLimitRC)
        {
          localStorage.setItem('limit_remaining_coupon', Number(prevLimitRC) + 1);
        }
      }
      var prevLimitDRC  = localStorage.getItem('limit_discount_remaining_coupon') ? localStorage.getItem('limit_discount_remaining_coupon') : 0;
      if (masterLimit)
      {
        if (masterLimit > prevLimitDRC)
        {
          localStorage.setItem('limit_discount_remaining_coupon', Number(prevLimitDRC) + 1);
        }
      }

      var prevLimitDCC  = localStorage.getItem('limit_discount_custom_coupon') ? localStorage.getItem('limit_discount_custom_coupon') : 0;
      if (masterLimit)
      {
        if (masterLimit > prevLimitDCC)
        {
          localStorage.setItem('limit_discount_custom_coupon', Number(prevLimitDCC) + 1);
        }
      }
    }
  }

  removeWaitingList(index, data) {

    var cart = localStorage.getItem('mycart');
    if (cart == '[]') {
      localStorage.setItem('mycart', '{}');
      return;
    }

    var found = '',
      item_found = 0;
    cart = JSON.parse(localStorage.getItem('mycart'));

    if (_buyNow) {
      cart = {};
      cart[_buyNow] = _buyNowDetails;
      // delete cart[index].learners[data.email];
      delete cart[index].waitingList[data.email];
      _buyNowDetails = cart[_buyNow];
      return;
    }

    if (__isLoggedin) {
      fetch(api_url + '/removeWaitingList', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data ? JSON.stringify({ data: data, index: index }) : '{}',
      })
        .then()
        .then()
        .catch();
    }

    delete cart[index].waitingList[data.email];
    localStorage.setItem('mycart', JSON.stringify(cart));

    // LIMIT MANAGEMENT
    if (data.total_after_discount && data.total_after_discount > 0) {
      var masterLimit = localStorage.getItem('main_coupon_limit') ? localStorage.getItem('main_coupon_limit') : 0;
      var prevLimitRC = localStorage.getItem('limit_remaining_coupon') ? localStorage.getItem('limit_remaining_coupon') : 0;

      if (masterLimit)
      {
        if (masterLimit > prevLimitRC)
        {
          localStorage.setItem('limit_remaining_coupon', Number(prevLimitRC) + 1);
        }
      }
      var prevLimitDRC  = localStorage.getItem('limit_discount_remaining_coupon') ? localStorage.getItem('limit_discount_remaining_coupon') : 0;
      if (masterLimit)
      {
        if (masterLimit > prevLimitDRC)
        {
          localStorage.setItem('limit_discount_remaining_coupon', Number(prevLimitDRC) + 1);
        }
      }

      var prevLimitDCC  = localStorage.getItem('limit_discount_custom_coupon') ? localStorage.getItem('limit_discount_custom_coupon') : 0;
      if (masterLimit)
      {
        if (masterLimit > prevLimitDCC)
        {
          localStorage.setItem('limit_discount_custom_coupon', Number(prevLimitDCC) + 1);
        }
      }
    }
  }

  saveAddress(data) {
    // console.log('cartservice addlearner',oldindex,index,data);
    // var myaddress = localStorage.getItem('myaddress');
    // if (cart == "[]") {
    // 	localStorage.setItem('mycart', '{}');
    // }
    // else {
    // 	// database connection here
    // 	cart = JSON.parse(localStorage.getItem('mycart'));
    // 	if (oldindex) {
    // 		delete cart[index].learners[oldindex];
    // 	}

    // 	cart[index].learners[data.email] = data;
    // 	cart[index].learners = {...cart[index].learners};
    // 	// console.log(cart[index].learners);
    // 	// console.log({...cart[index].learners});

    if (__isLoggedin) {
      fetch(api_url + '/addaddress', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data ? JSON.stringify({ data: data }) : '{}',
      })
        .then()
        .then()
        .catch();
    }

    if (data) localStorage.setItem('myaddress', JSON.stringify(data));

    // }
  }

  getAddress() {
    var myaddress = localStorage.getItem('myaddress');
    if (myaddress == '[]' || myaddress == '{}' || !myaddress) {
      return {};
    } else {
      myaddress = JSON.parse(localStorage.getItem('myaddress'));
      return myaddress;
    }
    // load from api
  }

  showDetailCollectionPop() {
    if (!_bfo && _guest_enabled && !__isLoggedin) return true; // collect guest data profile fields

    // guest cheking only if its not logged in and not bfo
    if (!_bfo && _concent.status) return true; //collect concent just concent checkbox
    // _additional fields // need more info
    if (!_bfo && this.is_pps_required()) return true; // pps data

    if (!_bfo && organistion_required) return true; // org data
  }

  get_metadata(key = '') {
    if (_buyNow) {
      // key = _buyNow;
      // var	cart = {};
      return _buyNowDetails.metadata;
    }

    if (key) {
      var cart = JSON.parse(localStorage.getItem('mycart'));
      return cart[key].metadata;
    }
    return null;
  }

  save_metadata(key = '', data = {}) {
    if (key && data && data.email) {
      if (_buyNow) {
        key = _buyNow;
        var cart = {};
        cart[_buyNow] = _buyNowDetails;
      } else {
        var cart = JSON.parse(localStorage.getItem('mycart'));
      }
      var _metadata = {};
      _metadata = cart[key].metadata ? cart[key].metadata : {};
      if (Array.isArray(_metadata)) _metadata = Object.assign({}, _metadata);
      _metadata[data.email] = data;
      cart[key].metadata = _metadata;
      // console.log('save metadata',key,data,cart);
      if (_buyNow) {
        _buyNowDetails = cart[_buyNow];
      } else {
        localStorage.setItem('mycart', JSON.stringify(cart));
      }
    }
  }
}

var cartService;
export default cartService = new CartService();
